'use strict';

import cookie from 'cookie';
import request from 'request-promise';

const Clerk =
{
	endpointBase:'https://api.clerk.io/v2/',
	apiKey:null,
	language:null,
	visitorID:null,
	globalFilter:'',
	init: (apiKey, globalFilter, language) =>
	{	//2015-05-20
		Clerk.apiKey = apiKey;
		Clerk.globalFilter = (globalFilter||Clerk.globalFilter);
		Clerk.language = (language||Clerk.language);
		
		Clerk.visitorID = cookie.getCookie('ClerkVisitor');
		if(typeof(Clerk.visitorID) !== 'string')
		{
			Clerk.visitorID = Clerk.generateUUID();
			cookie.setCookie('ClerkVisitor', Clerk.visitorID, 365, '/');
		}
		
		var pendingProductID = cookie.getCookie('ClerkPendingClick');
		if(typeof(pendingProductID) === 'string' && pendingProductID.match(/^[0-9]+$/) !== null) Clerk.call('log/click', {product:pendingProductID}, function()
		{
			cookie.eraseCookie('ClerkPendingClick', '');
		});
		
		console.debug('clerkinit');
		window.dispatchEvent(new Event('clerkinit'));
	},
	generateUUID:function()
	{	//2015-05-20	credit: http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript#answer-2117523
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c)
		{
			var r = (Math.random()*16|0);
			return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
		});
	},
	compileFilter:function(customFilter)
	{	//2015-04-20
		customFilter = (customFilter||'');
		
		if(customFilter.length !== 0 && Clerk.globalFilter.length !== 0) return '('+customFilter+') and ('+Clerk.globalFilter+')';
		
		return (customFilter||Clerk.globalFilter||'');
	},
	call: (endpoint, options, callback) =>
	{	//2015-04-20
		var callback = (callback||()=>{});
		
		return new Promise((resolve, reject) =>
		{
			if(Clerk.apiKey === null) reject('Clerk: Not initialized');
			
			options = (options||{});
			options.key = Clerk.apiKey;
			options.visitor = Clerk.visitorID;
			if(Clerk.language !== null) options.language = Clerk.language;
			
			var url = Clerk.endpointBase+endpoint+'?callback=?';
			
			request.getURL(url, { payload: JSON.stringify(options) }, { mode: 'cors' }).then(response =>
			{
				if(response.status !== 'ok') return reject();
				
				callback(response);
			})
			.catch(error =>
			{
				reject(error);
			});
		});
	},
	compileTemplate:function(template, vars)
	{	//2015-04-21
		return template.replace(/\{\{\{([a-z0-9_-]+)\}\}\}/mg, function(matchString, variableName)
		{
			if(typeof(vars[variableName]) !== 'undefined') return vars[variableName];
			
			return '';
		});
	},
	logClick:function(productID)
	{	//2015-05-20
		cookie.setCookie('ClerkPendingClick', productID);
	},
	logSale:function(orderID, customerID, products, email)
	{	//2015-05-20
		var options = {};
		options.sale = orderID;
		options.customer = customerID;
		options.products = products;
		if(typeof(email) === 'string') options.email = email;
		
		return Clerk.call('log/sale', options);
	},
	logEmail:function(email)
	{	//2015-06-18
		var options = {};
		options.email = email;
		
		return Clerk.call('log/email', options);
	},
	//previously "search"
	search:function(query, callback, filter, limit)
	{	//2015-04-20
		var options = {};
		options.query = query;
		options.limit = (limit||100);
		options.filter = Clerk.compileFilter(filter);
		
		return Clerk.call('search/search', options, callback);
	},
	//previously "related"
	getRelatedProducts:function(productIDs, callback, filter, limit, labels)
	{	//2015-04-20
		var options = {};
		options.products = (productIDs||[]);
		options.limit = (limit||100);
		options.filter = Clerk.compileFilter(filter);
		options.labels = ['Related Products'].concat(labels || []);
		
		return Clerk.call('recommendations/complementary', options, callback);
	},
	//previously "alternative"
	getAlternativeProducts:function(productIDs, callback, filter, limit, labels)
	{	//2015-04-20
		var options = {};
		options.products = (productIDs||[]);
		options.limit = (limit||100);
		options.filter = Clerk.compileFilter(filter);
		options.labels = ['Alternative Products'].concat(labels || []);
		
		return Clerk.call('recommendations/substituting', options, callback);
	},
	//previously "category_popular"
	getPopularInCategory:function(categoryID, callback, filter, limit, labels)
	{	//2015-04-20
		var options = {};
		options.category = categoryID;
		options.limit = (limit||100);
		options.filter = Clerk.compileFilter(filter);
		options.labels = ['Popular In Category'].concat(labels || []);
		
		return Clerk.call('recommendations/category/popular', options, callback);
	},
	getPopularProducts:function(callback, filter, limit, labels)
	{	//2015-04-20
		var options = {};
		options.limit = (limit||100);
		options.filter = Clerk.compileFilter(filter);
		options.labels = ['Popular Products'].concat(labels || []);
		
		return Clerk.call('recommendations/visitor/complementary', options, callback);
	},
	getTrendingProducts:function(callback, filter, limit, labels)
	{	//2015-04-20
		var options = {};
		options.limit = (limit||100);
		options.filter = Clerk.compileFilter(filter);
		options.labels = ['Trending Products'].concat(labels || []);
		
		return Clerk.call('recommendations/trending', options, callback);
	}
};

export default Clerk;
